import PlayerForm from "./PlayerForm";

const TeamForm = ({ handleChange, maxDate, playersData }) => {

  return (
    <section
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        padding: "0 10px",
      }}
    >
      {playersData &&
        playersData.map((p, index) => (
          <PlayerForm key={index} handleChange={handleChange} index={index} maxDate={maxDate}/>
        ))}
    </section>
  );
};

export default TeamForm;
